var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M7.414 6l4.242-4.242a.998.998 0 0 0 0-1.415.998.998 0 0 0-1.414 0L6 4.587 1.758.344a.998.998 0 0 0-1.415 0 .998.998 0 0 0 0 1.414L4.587 6 .344 10.242a.998.998 0 0 0 0 1.415.998.998 0 0 0 1.414 0L6 7.413l4.242 4.242a.998.998 0 0 0 1.415 0 .998.998 0 0 0 0-1.414L7.413 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCross);
export default __webpack_public_path__ + "static/media/close-cross.d1f603ec2e890165113fed6c055942fc.svg";
export { ForwardRef as ReactComponent };